const initialState = {
  googleProfile: null,
  studentUser: null,
  studentSlots: [],
  studentChoices: null,
  currentDiscipline: null,
};

export default initialState;